import React from 'react';
import Lottie from 'lottie-react';
import Error from '../../assets/animations/OhSnap.json';
import './Error403.scss';

export default function Error403() {
  return (
    <div className="container">
      <Lottie animationData={Error} loop className="lottie" />
      <span className="container__label"> Oops! Something went wrong</span>
    </div>
  );
}
